export const ErrorHandlerMixin = {
  methods: {
    errorHandler (err) {
      const message = err?.response?.data?.message || err.message
      const messageHtml = err?.response?.data?.message_html || null
      const code = err?.response?.data?.error_code || 500
      const restrictionAction = err?.response?.data?.restriction_action || null
      const redirectUrl = err?.response?.data?.redirect_url || null

      if (restrictionAction === 'redirect' && redirectUrl) {
        window.location.href = redirectUrl
        return
      }

      if(code === 422){
        this.$root.$emit('validation-error', message)
        return;
      }
      this.error = {
        code: code,
        html: messageHtml,
        message: messageHtml ? null : (this.$t(`errors.${message}`) || message)
      }
    },
  }
}
